// extracted by mini-css-extract-plugin
export default {"main":"Images_main__SrBY7","button-text":"Images_button-text__F7Ejg"};